import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  Box,
  DialogContentText,
  Typography,
} from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConcluirProducao = ({
  openDialogConcluirProducao,
  onClose,
  producaoSelecionada,
  atualizaProducao,
  proximaMaquina,
}) => {
  console.log(proximaMaquina);
  return (
    <Dialog
      open={openDialogConcluirProducao}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>BAIXA PRODUÇÃO</DialogTitle>
      <DialogContent dividers>
        <DialogContent dividers>
          <DialogContentText>
            DIGITE A QUANTIDADE DE CAIXAS PRODUZIDAS
          </DialogContentText>
          <DialogContentText>
            NA ORDEM : {producaoSelecionada}
          </DialogContentText>
        </DialogContent>
        {proximaMaquina ? (
          proximaMaquina.codigo !== 0 ? (
            <DialogContent sx={{ background: 'red' }}>
              <Typography variant="h6" sx={{ color: 'white' }}>
                ENVIAR PARA A MAQUINA: {proximaMaquina.maquina}
              </Typography>
            </DialogContent>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}

        <Box mt={2} mb={2}></Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-around' }}>
        <Button onClick={onClose}>Fechar</Button>
        <Button
          onClick={() => {
            atualizaProducao(producaoSelecionada, proximaMaquina.maquina);
          }}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConcluirProducao;
